module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1036-5c667c1fba3a568996976277823acf22.png";